import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { LanguageProvider } from "./i18n";
import { RenderErrorBoundary } from "./RenderErrorBoundary";
import "./styles.css";
import "./i18n.css";
import "./marketing.css";
import "./marketing-deferred.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <RenderErrorBoundary>
      <LanguageProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </LanguageProvider>
    </RenderErrorBoundary>
  </React.StrictMode>,
);
